'use client'
// =============================================================================
// HumanRequestsPanel — demandes humaines en attente (Mission Control).
// Les missions WAITING_USER dont Skynet a besoin d'un humain : question ou
// tâche à accomplir, triée par rôle (👑/🛡/👤), XP à la clé. Le traitement se
// fait dans /projets (Journal Autonome) — ici, la vigie.
// =============================================================================
import { useEffect, useState } from 'react'
import { useSession } from 'next-auth/react'
import { isAdminUser } from '@/lib/is-admin'

interface WaitingMission {
  id: string; objective: string; userQuestion?: string | null; waitingSince?: string | null
  context?: { humanRole?: string; humanInstructions?: string; humanXp?: number } | null
}

const ROLE_BADGE: Record<string, { label: string; color: string }> = {
  SUPER_ADMIN: { label: '👑 SUPER-ADMIN', color: '#ef4444' },
  ADMIN:       { label: '🛡 ADMIN',        color: '#ef4444' },
  USER:        { label: '👤 USAGER',       color: '#00d4ff' },
}

export function HumanRequestsPanel() {
  const [items, setItems] = useState<WaitingMission[]>([])
  const { data: session } = useSession()
  const isAdmin = isAdminUser(session?.user as never)

  useEffect(() => {
    const load = () => {
      fetch(`/api/missions?status=WAITING_USER&limit=20${isAdmin ? '&all=1' : ''}`)
        .then(r => (r.ok ? r.json() : null))
        .then(d => setItems(Array.isArray(d) ? d : []))
        .catch(() => setItems([]))
    }
    load()
    const iv = setInterval(load, 60_000)
    return () => clearInterval(iv)
  }, [isAdmin])

  if (!items.length) return null

  return (
    <div style={{ marginBottom: 20 }}>
      <div style={{ fontSize: 10, fontFamily: 'var(--font-mono)', fontWeight: 700, letterSpacing: '0.12em', color: '#f5a623', marginBottom: 8 }}>
        ⏸ SKYNET A BESOIN D'UN HUMAIN ({items.length})
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {items.map(m => {
          const badge = ROLE_BADGE[m.context?.humanRole ?? ''] ?? null
          return (
            <a key={m.id} href="/projets"
              style={{ display: 'block', padding: '8px 10px', borderRadius: 8, textDecoration: 'none',
                background: 'rgba(245,166,35,0.06)', border: '1px solid rgba(245,166,35,0.25)' }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: '#e2e8f0', display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
                {m.objective}
                {badge && <span style={{ fontSize: 8, fontFamily: 'var(--font-mono)', fontWeight: 800, padding: '1px 6px', borderRadius: 7, color: badge.color, border: `1px solid ${badge.color}45` }}>{badge.label}</span>}
                {(m.context?.humanXp ?? 0) > 0 && <span style={{ fontSize: 8, fontFamily: 'var(--font-mono)', fontWeight: 800, color: '#34d399' }}>⭐ +{m.context!.humanXp} XP</span>}
              </div>
              {m.userQuestion && <div style={{ fontSize: 10, color: '#fbd38d', marginTop: 3, lineHeight: 1.5 }}>❓ {m.userQuestion}</div>}
            </a>
          )
        })}
      </div>
    </div>
  )
}
